import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { FaInstagram } from 'react-icons/fa';

import IntroductionBanner from 'component/IntroductionBanner';
import FrameL, { Img } from 'component/FrameL';
import Carousel from 'component/Carousel';
import FeatureTile from 'component/FeatureTile';
import './style.css';

const Review = ({ review }) => {
    const { heading, subheading, description } = review;
    return <div className='text-center max-w-screen-md mx-auto'>
        <h3>{heading}</h3>
        <h4 className='italic mt-0'>{subheading}</h4>
        <ReactMarkdown>{description}</ReactMarkdown>
    </div>
}

const SocialTile = ({ socialTile }) => {
    const { heading, instagram, photo, link, blurb } = socialTile;

    return <a href={link}>
        <FrameL ratio='1:1' Image={photo}>
            {/* <div className='flex flex-col justify-center'> */}
            <div className='home__socialTile bg-black bg-opacity-80 flex-col p-8'>
                <div className='text-center text-white flex-grow stack-l border border-white p-4'
                    style={{ "--justify": "center" }}>
                    <h6>{heading}</h6>
                    <ReactMarkdown>{blurb}</ReactMarkdown>
                    <span><FaInstagram className='icon'></FaInstagram> {instagram}</span>
                </div>
            </div>
            {/* </div> */}
        </FrameL>
    </a>
}



export default ({ cmsData }) => {
    const { introduction = {}, reviews = [], sections = [], socialTiles = [], heroVideo = {}, featured = {} } = cmsData;
    const { photo, heading, description } = introduction;
    return <main className="stack-l xl:container mx-auto pb-16 px-4" style={{ "--space": "var(--s4)" }}>
        <section className="break-out-banner relative">
            <FrameL Image={heroVideo} fixedHeight='95vh'></FrameL>
            <FeatureTile featured={featured}></FeatureTile>
        </section>

        <section className='home__introGrid'>
            <Img Image={photo}></Img>
            <div>
                <h3 className='text-5xl text-accent text-center'>{heading}</h3>
                <ReactMarkdown>{description}</ReactMarkdown>
            </div>
        </section>

        <section className='bg-green-300 p-2 break-out-banner'>
            <Carousel className='p-8' fixedHeight="50vh">
                {reviews.map((review, i) => {
                    return <Review key={i} review={review}></Review>
                })}
            </Carousel>
        </section>

        <section>
            {sections.map((section, i) => {
                return <IntroductionBanner key={i} cmsData={section} reverse={i % 2 === 1} />
            })}
        </section>

        <section>
            <h3 className='text-5xl text-accent text-center'>#Social Life</h3>
            <div className='switcher-l mt-4'>
                {socialTiles.map(socialTile => {
                    return <SocialTile socialTile={socialTile}></SocialTile>
                })}
            </div>
        </section>
    </main >
}